export const BLOG_TYPES = [
  {
    label: 'All Blogs',
    value: 'All',
  },
  {
    label: 'CredibleMind Blogs',
    value: 'crediblemind',
  },
  {
    label: 'Guest Blogs',
    value: 'Guest',
  },
];

export const PROCESSING = 'app/Blogs/PROCESSING';
export const NEXT_PAGE_PROCESSING = 'app/Blogs/NEXT_PAGE_PROCESSING';
export const GET_BLOGS = 'app/Blogs/GET_BLOGS';
export const GET_BLOGS_RESULT = 'app/Blogs/GET_BLOGS_RESULT';
export const GET_BLOGS_TOPIC_FACETS = 'app/Blogs/GET_BLOGS_TOPIC_FACETS';
export const GET_BLOGS_TOPIC_FACETS_RESULT =
  'app/Blogs/GET_BLOGS_TOPIC_FACETS_RESULT';
